import LandaFinancingActivity from 'pages/lend/components/LandaFinancingActivity';
import LandaFinancingDividends from 'pages/lend/components/LandaFinancingDividends';
import LandaFinancingFAQ from 'pages/lend/components/LandaFinancingFAQ';
import LandaFinancingForm from 'pages/lend/components/LandaFinancingForm';
import LandaFinancingMap from 'pages/lend/components/LandaFinancingMap';
import LandaFinancingUtilizationRate from 'pages/lend/components/LandaFinancingUtilizationRate';
import { FC } from 'react';
import { DebtType } from 'types/debt-types';

export const DEBT_TICKER = 'LANDA_FINANCING';

export const LANDA_FINANCING_LEFT_COMPONENTS: {
  Component: FC<{ debt: DebtType }>;
  key: string;
}[] = [
  // {
  //   Component: LandaFinancingDividends, // TEMPORARY STOP: dividends delivered section
  //   key: 'dividends',
  // },
  // {
  //   Component: LandaFinancingCollectionRate,
  //   key: 'collection-rate',
  // },
  {
    Component: LandaFinancingUtilizationRate,
    key: 'utilization-rate',
  },
  {
    Component: LandaFinancingMap,
    key: 'map',
  },
  {
    Component: LandaFinancingFAQ,
    key: 'faq',
  },
];

export const LANDA_FINANCING_RIGHT_COMPONENTS: {
  Component: FC<{ debt: DebtType }>;
  key: string;
}[] = [
  {
    Component: LandaFinancingForm,
    key: 'debt-form',
  },
  {
    Component: LandaFinancingActivity,
    key: 'activity',
  },
];
